/**
 * THE REFERRAL CODE OF THE LINK THAT BROUGHT A VISITOR (`twoke.io/?ref=twokeio-…`, or typed at
 * sign-up), kept in this browser until the visitor is signed in, then attached once by the app
 * shell (POST /me/referral/attach). The server decides whether it counts (an approved code, a user
 * who never paid, not one's own); this only carries it. Kept 30 days.
 */
const KEY = "twoke.ref";
const TTL_MS = 30 * 86_400_000;
export const REFERRAL_CODE_RE = /^twokeio-[a-z0-9-]{2,40}$/;

export function storeReferralCode(code: string): void {
  const c = code.trim().toLowerCase();
  if (!REFERRAL_CODE_RE.test(c)) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ code: c, at: Date.now() }));
  } catch {
    // storage blocked: the code can still be typed in the subscribe window
  }
}

export function pendingReferralCode(): string | null {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? "null") as { code?: string; at?: number } | null;
    if (!v?.code || !REFERRAL_CODE_RE.test(v.code) || Date.now() - (v.at ?? 0) > TTL_MS) return null;
    return v.code;
  } catch {
    return null;
  }
}

export function clearReferralCode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
